import store from '../stores/store'

// pass in any text string into message variable
// messageTypes: 'success', 'info', 'warning', 'danger'

export const setNotification = function(message, messageType){
  const $store = store
  const msg = {message, messageType}
  $store.dispatch('setNotification', msg)
}